import {
  ICC_UNLOCKING,
  ICC_UNLOCKING_ERROR,
  ICC_UNLOCKING_CLEAN,
  ICC_UNLOCKING_CLEAN_ERROR,
} from '_models/redux/types';

const initialState = {
  changeNir: [],
  error: undefined,
  loading: false,
};

export default function iccUnlockingReducer(state = initialState, action) {
  switch (action.type) {
    case ICC_UNLOCKING:
    case ICC_UNLOCKING_CLEAN:
      return {
        ...state,
        changeNir: action.payload,
        loading: true,
      };

    case ICC_UNLOCKING_ERROR:
    case ICC_UNLOCKING_CLEAN_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
}
